import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './app/globals.css';
import { API_BASE } from './lib/rpc';
import { initClientTelemetry } from './lib/telemetry';

// Initialize global window exception and unhandled rejection telemetry
initClientTelemetry('dashboard');

// Monkey patch global fetch to automatically inject JWT token for API requests
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  let [resource, config] = args;
  let url = '';
  if (typeof resource === 'string') {
    url = resource;
  } else if (resource instanceof Request) {
    url = resource.url;
  } else if (resource instanceof URL) {
    url = resource.toString();
  }

  if (url.startsWith(API_BASE) || url.startsWith('/') || url.includes('dark.tel/api')) {
    let token = '';
    try {
      const stored = localStorage.getItem('dark_session');
      if (stored) {
        const parsed = JSON.parse(stored);
        if (parsed.token) token = parsed.token;
      }
    } catch(e) {}
    if (token) {
      config = config || {};
      const headers = new Headers(config.headers || {});
      
      // If resource is a Request object, extract its headers first
      if (resource instanceof Request) {
         resource.headers.forEach((value, key) => {
            if (!headers.has(key)) headers.set(key, value);
         });
      }
      
      headers.set('Authorization', `Bearer ${token}`);
      config.headers = headers;
      
      // If resource was a Request, we must pass its URL as a string to avoid conflicts
      // when overriding headers, or recreate the Request. Passing url string is safer.
      if (resource instanceof Request) {
          return originalFetch(url, config);
      }
      return originalFetch(resource, config);
    }
  }
  return originalFetch(...args);
};

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
